import { createContext, use } from 'react'

const ScrollContainerContext = createContext<HTMLDivElement | null>(null)

export const useScrollContainer = () => {
  const scrollContainer = use(ScrollContainerContext)
  return scrollContainer
}
